import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Row, Col, Card, Form, Input, Checkbox } from 'antd'

const FormItem = Form.Item

const CandidateExperienceDetailsStep = ({
  form,
  profile,
  candidateExperienceDetailsData,
}) => {
  const { getFieldDecorator } = form

  if (isEmpty(candidateExperienceDetailsData)) {
    return (
      <React.Fragment>
        {/* Type of Activities Section */}
        <Card title="Type of Activities" type="inner">
          <Row>
            <Col span={6}>
              <FormItem
                label="Needs Assessment"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('assessment', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Proposal Writing"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Proposal', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Program"
                labelCol={{ span: 18 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Program', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Baseline"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('baseline', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <FormItem
                label="Mid-Term Evaluation"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('MidEval', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Final Evaluation"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('FinEval', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Research"
                labelCol={{ span: 18 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('research', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Training"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Training', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <FormItem
                label="Monitoring"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Monitoring', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Third Party Monitoring"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('ThirdPartyMonitoring', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Survey"
                labelCol={{ span: 18 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Survey', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem
                label="Rigorous Impact Assessment"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('ImpactAssessment', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        {/* Crisis Intervention Section */}
        <Card title="Crisis Intervention" type="inner">
          <Row>
            <Col span={3}>
              <FormItem
                label="Flood"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Flood', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Drought"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Drought', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Tsunami"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Tsunami', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Displaced/Ref"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Displaced', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Conflict"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Conflict', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Epidemic"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Epidemic', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Development"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('development', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem
                label="Others"
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                {getFieldDecorator(
                  'othercrisis',
                  {}
                )(<Input placeholder="Enter other crisis" />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        {/* Clients Section */}
        <Card title="Clients" type="inner">
          <Row>
            <Col span={3}>
              <FormItem
                label="NGO"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('ClientNGO', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="EU"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('EU', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="DFID"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('DFID', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="USAID"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('USAID', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="DANIDA"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('DANIDA', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="SIDA"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('SIDA', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="CIDA"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('CIDA', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="NORAD"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('NORAD', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={3}>
              <FormItem
                label="AusAid"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('AusAID', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="JICA"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('JICA', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="UNDP"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('UNDP', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="WFP"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('WFP', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="WB"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('WB', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="HCR"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('HCR', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="UNICEF"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('UNICEF', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="UN HABITAT"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('UNHABITAT', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem
                label="Others"
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                {getFieldDecorator(
                  'otherClients',
                  {}
                )(<Input placeholder="Enter other clients" />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        {/* Areas of Expertise Section */}
        <Card title="Areas of Expertise" type="inner">
          <Row>
            <Col span={4}>
              <FormItem
                label="ME"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('ME', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Water and Sanitation"
                labelCol={{ span: 23 }}
                wrapperCol={{ span: 1 }}
              >
                {getFieldDecorator('WaterandSanitation', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Protection"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Protection', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Livelihood"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Livelihood', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="GIS"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('GIS', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Finance"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Finance', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <FormItem
                label="Logistic"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Logistic', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Human Right"
                labelCol={{ span: 23 }}
                wrapperCol={{ span: 1 }}
              >
                {getFieldDecorator('HumanRight', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Advocacy"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Advocacy', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="HIV"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('HIV', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Gender"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Gender', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Environment"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('environment', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <FormItem
                label="Health"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Health', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Agriculture"
                labelCol={{ span: 23 }}
                wrapperCol={{ span: 1 }}
              >
                {getFieldDecorator('Agriculture', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Nutrition"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Nutrition', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Governance"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Governance', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Poverty"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Poverty', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Administration"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Administration', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <FormItem
                label="Education"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Education', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Business"
                labelCol={{ span: 23 }}
                wrapperCol={{ span: 1 }}
              >
                {getFieldDecorator('Business', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Distribution"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Distribution', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Livestock"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Livestock', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Stabilization"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Stabilization', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Resilience"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Resilience', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <FormItem
                label="Security"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Security', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Data Management"
                labelCol={{ span: 23 }}
                wrapperCol={{ span: 1 }}
              >
                {getFieldDecorator('DataManagement', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                label="Sampling"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('Sampling', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {/* Type of Activities Section */}
      <Card title="Type of Activities" type="inner">
        <Row>
          <Col span={6}>
            <FormItem
              label="Needs Assessment"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('assessment', {
                initialValue:
                  candidateExperienceDetailsData.assessment === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Proposal Writing"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Proposal', {
                initialValue:
                  candidateExperienceDetailsData.Proposal === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Program"
              labelCol={{ span: 18 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Program', {
                initialValue:
                  candidateExperienceDetailsData.Program === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Baseline"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('baseline', {
                initialValue:
                  candidateExperienceDetailsData.baseline === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <FormItem
              label="Mid-Term Evaluation"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('MidEval', {
                initialValue:
                  candidateExperienceDetailsData.MidEval === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Final Evaluation"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('FinEval', {
                initialValue:
                  candidateExperienceDetailsData.FinEval === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Research"
              labelCol={{ span: 18 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('research', {
                initialValue:
                  candidateExperienceDetailsData.research === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Training"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Training', {
                initialValue:
                  candidateExperienceDetailsData.Training === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <FormItem
              label="Monitoring"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Monitoring', {
                initialValue:
                  candidateExperienceDetailsData.Monitoring === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Third Party Monitoring"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('ThirdPartyMonitoring', {
                initialValue:
                  candidateExperienceDetailsData.ThirdPartyMonitoring === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Survey"
              labelCol={{ span: 18 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Survey', {
                initialValue:
                  candidateExperienceDetailsData.Survey === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              label="Rigorous Impact Assessment"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('ImpactAssessment', {
                initialValue:
                  candidateExperienceDetailsData.ImpactAssessment === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
      </Card>
      {/* Crisis Intervention Section */}
      <Card title="Crisis Intervention" type="inner">
        <Row>
          <Col span={3}>
            <FormItem
              label="Flood"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Flood', {
                initialValue:
                  candidateExperienceDetailsData.Flood === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Drought"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Drought', {
                initialValue:
                  candidateExperienceDetailsData.Drought === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Tsunami"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Tsunami', {
                initialValue:
                  candidateExperienceDetailsData.Tsunami === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Displaced/Ref"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Displaced', {
                initialValue:
                  candidateExperienceDetailsData.Displaced === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Conflict"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Conflict', {
                initialValue:
                  candidateExperienceDetailsData.Conflict === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Epidemic"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Epidemic', {
                initialValue:
                  candidateExperienceDetailsData.Epidemic === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Development"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('development', {
                initialValue:
                  candidateExperienceDetailsData.development === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem
              label="Others"
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              {getFieldDecorator('othercrisis', {
                initialValue: candidateExperienceDetailsData.othercrisis
                  ? candidateExperienceDetailsData.othercrisis
                  : '',
              })(<Input placeholder="Enter other crisis" />)}
            </FormItem>
          </Col>
        </Row>
      </Card>
      {/* Clients Section */}
      <Card title="Clients" type="inner">
        <Row>
          <Col span={3}>
            <FormItem
              label="NGO"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('ClientNGO', {
                initialValue:
                  candidateExperienceDetailsData.ClientNGO === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="EU"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('EU', {
                initialValue:
                  candidateExperienceDetailsData.EU === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="DFID"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('DFID', {
                initialValue:
                  candidateExperienceDetailsData.DFID === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="USAID"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('USAID', {
                initialValue:
                  candidateExperienceDetailsData.USAID === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="DANIDA"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('DANIDA', {
                initialValue:
                  candidateExperienceDetailsData.DANIDA === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="SIDA"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('SIDA', {
                initialValue:
                  candidateExperienceDetailsData.SIDA === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="CIDA"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('CIDA', {
                initialValue:
                  candidateExperienceDetailsData.CIDA === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="NORAD"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('NORAD', {
                initialValue:
                  candidateExperienceDetailsData.NORAD === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={3}>
            <FormItem
              label="AusAid"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('AusAID', {
                initialValue:
                  candidateExperienceDetailsData.AusAID === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="JICA"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('JICA', {
                initialValue:
                  candidateExperienceDetailsData.JICA === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="UNDP"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('UNDP', {
                initialValue:
                  candidateExperienceDetailsData.UNDP === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="WFP"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('WFP', {
                initialValue:
                  candidateExperienceDetailsData.WFP === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="WB"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('WB', {
                initialValue:
                  candidateExperienceDetailsData.WB === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="HCR"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('HCR', {
                initialValue:
                  candidateExperienceDetailsData.HCR === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="UNICEF"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('UNICEF', {
                initialValue:
                  candidateExperienceDetailsData.UNICEF === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="UN HABITAT"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('UNHABITAT', {
                initialValue:
                  candidateExperienceDetailsData.UNHABITAT === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem
              label="Others"
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              {getFieldDecorator('otherClients', {
                initialValue: candidateExperienceDetailsData.otherClients
                  ? candidateExperienceDetailsData.otherClients
                  : '',
              })(<Input placeholder="Enter other clients" />)}
            </FormItem>
          </Col>
        </Row>
      </Card>
      {/* Areas of Expertise Section */}
      <Card title="Areas of Expertise" type="inner">
        <Row>
          <Col span={4}>
            <FormItem
              label="ME"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('ME', {
                initialValue:
                  candidateExperienceDetailsData.ME === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Water and Sanitation"
              labelCol={{ span: 23 }}
              wrapperCol={{ span: 1 }}
            >
              {getFieldDecorator('WaterandSanitation', {
                initialValue:
                  candidateExperienceDetailsData.WaterandSanitation === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Protection"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Protection', {
                initialValue:
                  candidateExperienceDetailsData.Protection === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Livelihood"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Livelihood', {
                initialValue:
                  candidateExperienceDetailsData.Livelihood === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="GIS"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('GIS', {
                initialValue:
                  candidateExperienceDetailsData.GIS === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Finance"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Finance', {
                initialValue:
                  candidateExperienceDetailsData.Finance === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={4}>
            <FormItem
              label="Logistic"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Logistic', {
                initialValue:
                  candidateExperienceDetailsData.Logistic === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Human Right"
              labelCol={{ span: 23 }}
              wrapperCol={{ span: 1 }}
            >
              {getFieldDecorator('HumanRight', {
                initialValue:
                  candidateExperienceDetailsData.HumanRight === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Advocacy"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Advocacy', {
                initialValue:
                  candidateExperienceDetailsData.Advocacy === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="HIV"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('HIV', {
                initialValue:
                  candidateExperienceDetailsData.HIV === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Gender"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Gender', {
                initialValue:
                  candidateExperienceDetailsData.Gender === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Environment"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('environment', {
                initialValue:
                  candidateExperienceDetailsData.environment === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={4}>
            <FormItem
              label="Health"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Health', {
                initialValue:
                  candidateExperienceDetailsData.Health === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Agriculture"
              labelCol={{ span: 23 }}
              wrapperCol={{ span: 1 }}
            >
              {getFieldDecorator('Agriculture', {
                initialValue:
                  candidateExperienceDetailsData.Agriculture === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Nutrition"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Nutrition', {
                initialValue:
                  candidateExperienceDetailsData.Nutrition === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Governance"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Governance', {
                initialValue:
                  candidateExperienceDetailsData.Governance === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Poverty"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Poverty', {
                initialValue:
                  candidateExperienceDetailsData.Poverty === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Administration"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Administration', {
                initialValue:
                  candidateExperienceDetailsData.Administration === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={4}>
            <FormItem
              label="Education"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Education', {
                initialValue:
                  candidateExperienceDetailsData.Education === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Business"
              labelCol={{ span: 23 }}
              wrapperCol={{ span: 1 }}
            >
              {getFieldDecorator('Business', {
                initialValue:
                  candidateExperienceDetailsData.Business === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Distribution"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Distribution', {
                initialValue:
                  candidateExperienceDetailsData.Distribution === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Livestock"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Livestock', {
                initialValue:
                  candidateExperienceDetailsData.Livestock === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Stabilization"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Stabilization', {
                initialValue:
                  candidateExperienceDetailsData.Stabilization === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Resilience"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Resilience', {
                initialValue:
                  candidateExperienceDetailsData.Resilience === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={4}>
            <FormItem
              label="Security"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Security', {
                initialValue:
                  candidateExperienceDetailsData.Security === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Data Management"
              labelCol={{ span: 23 }}
              wrapperCol={{ span: 1 }}
            >
              {getFieldDecorator('DataManagement', {
                initialValue:
                  candidateExperienceDetailsData.DataManagement === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem
              label="Sampling"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('Sampling', {
                initialValue:
                  candidateExperienceDetailsData.Sampling === 'OK'
                    ? true
                    : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
      </Card>
    </React.Fragment>
  )
}

export default CandidateExperienceDetailsStep
